// uses ./navBar/navBar.less
import React from 'react';
import classNames from 'classnames';
import { useNavigate, useLocation } from 'react-router';
import t from '../../../translations';
import { RequiresConnect } from '../../common/platform/PlatformTools';
import AdminToggle from '../../user/AdminToggle';

const navbarTranslations = t.navbar;

function NavBar() {
    const location = useLocation();
    const navigate = useNavigate();

    const defaultClass = 'navBar-navigation__link';
    const defaultClassActive = `${defaultClass}--active`;
    const controlCenterActive = classNames(defaultClass, {
        [defaultClassActive]: location?.pathname === '/control-center',
    });
    const allActive = classNames(defaultClass, { [defaultClassActive]: location.pathname === '/apps' });

    return (
        <div className="navBar-wrapper">
            <div className="navBar-navigation">
                <h4
                    className={allActive}
                    onClick={() => {
                        navigate('/apps');
                    }}
                >
                    {navbarTranslations.all}
                </h4>
                <h4
                    className={controlCenterActive}
                    onClick={() => {
                        navigate('/control-center');
                    }}
                    data-pendoid="apps&Integration-AppControlCenter"
                >
                    {navbarTranslations.appCenter}
                </h4>
            </div>
            <RequiresConnect>
                <AdminToggle />
            </RequiresConnect>
        </div>
    );
}

export default NavBar;
